import { render, staticRenderFns } from "./iconGlass.vue?vue&type=template&id=23aa7fec&scoped=true"
import script from "./iconGlass.vue?vue&type=script&lang=js"
export * from "./iconGlass.vue?vue&type=script&lang=js"
import style0 from "./iconGlass.vue?vue&type=style&index=0&id=23aa7fec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aa7fec",
  null
  
)

export default component.exports